module.exports = __webpack_public_path__ + "static/media/ndi-user-guide.f03d1c44.pdf";